var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isReady
    ? _c(
        "div",
        {
          staticClass: "page-body content-inner",
          attrs: { "data-content-width": "wide" },
        },
        [
          _c(
            "md-dialog",
            {
              attrs: { "md-active": _vm.showRemoveConfirmation },
              on: {
                "update:mdActive": function ($event) {
                  _vm.showRemoveConfirmation = $event
                },
                "update:md-active": function ($event) {
                  _vm.showRemoveConfirmation = $event
                },
              },
            },
            [
              _c("md-dialog-title", [
                _vm._v(_vm._s(_vm.t("app-are-you-sure"))),
              ]),
              _vm._v(" "),
              _c("md-dialog-content", [
                _vm._v(
                  _vm._s(_vm.t("app-are-you-sure-you-want-to-delete")) + " "
                ),
                _c("i", [
                  _vm._v(
                    _vm._s(
                      _vm.program.localizedAttributes["en"].field_display_title
                    )
                  ),
                ]),
                _vm._v(". "),
                _c("b", [_vm._v(_vm._s(_vm.t("app-cannot-be-undone")))]),
              ]),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function ($event) {
                          _vm.showRemoveConfirmation = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("app-cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("app-delete")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "page-header typography" }, [
            _c("h1", [_vm._v(_vm._s(_vm.t("app-program-approval")))]),
          ]),
          _vm._v(" "),
          _vm.isReady
            ? _c(
                "form",
                {
                  staticClass: "standard-form-style",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.save()
                    },
                  },
                },
                [
                  _c("fieldset", [
                    _c("legend", [
                      _vm._v(
                        _vm._s(
                          _vm.t("app-program-settings-approval", {
                            programName:
                              _vm.program.localizedAttributes["en"]
                                .field_display_title,
                          })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.t("app-current-status")) + ": "),
                        _c("span", { class: _vm.approvalStatusColor }, [
                          _vm._v(_vm._s(_vm.t(`${_vm.approvalStatusValue}`))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ui-form-row" }, [
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.t("app-program-settings-description"))
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ui-form-row" },
                      [
                        _c("vuetable", {
                          ref: "my-vuetable",
                          attrs: {
                            "api-url": _vm.url,
                            "http-fetch": _vm.getData,
                            transform: _vm.transformData,
                            fields: _vm.fields,
                            "sort-order": _vm.sortOrder,
                            "show-sort-icons": true,
                            css: { tableClass: "ui-table" },
                            "no-data-template": _vm.t("app-no-data-available"),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ui-form-row col-2" },
                      [
                        _c("app-radios", {
                          attrs: {
                            name: "approval",
                            label: _vm.t("app-approval-program"),
                            options: _vm.optionsApproval,
                          },
                          model: {
                            value: _vm.approval.attributes.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.approval.attributes, "status", $$v)
                            },
                            expression: "approval.attributes.status",
                          },
                        }),
                        _vm._v(" "),
                        _vm.approval.attributes.status
                          ? _c(
                              "fieldset",
                              [
                                _c("div", { staticClass: "ui-form-row" }, [
                                  _c("legend", [
                                    _vm._v(
                                      _vm._s(_vm.t("app-approval-notes-legend"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "description" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("app-approval-notes-description")
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("app-textarea", {
                                  attrs: {
                                    label: _vm.t("app-approval-notes"),
                                    rows: 2,
                                  },
                                  model: {
                                    value: _vm.approval.attributes.notes,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.approval.attributes,
                                        "notes",
                                        $$v
                                      )
                                    },
                                    expression: "approval.attributes.notes",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui-form-row" }, [
                      _vm.approval.attributes.status
                        ? _c(
                            "button",
                            {
                              staticClass: "compact",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.clearApproval.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t("app-clear-approval")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("program-actions", {
                    attrs: { active: "approval", program: _vm.program },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }